module.exports = __webpack_public_path__ + "static/media/report.c33ee54c.svg";